<template>
  <div class="holder-groups" :class="[className, `${words.length}-len`]">
    <template v-for="(word, i) in words">
      <span v-if="word" :key="i" class="groups">
        <div class="group-1">
          <span class="first" :title="word">
            {{ word }}
            <span class="title-big-1" :title="word">{{ word }}</span>
          </span>
        </div>
        <div class="group-2">
          <span class="second" :title="word">
            {{ word }}
            <span class="title-big-1" :title="word">{{ word }}</span>
          </span>
        </div>
      </span>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    className: { type: String, default: '', required: false },
    words: { type: Array, default: () => [], required: true },
  },
};
</script>

<style lang="scss">
.holder-groups {
  position: relative;
  display: flex;
  justify-content: center;
  height: 55px;

  .groups {
    height: 100%;
    width: 100%;
    position: relative;

    .group-1,
    .group-2 {
      position: absolute;
      height: 50%;
      overflow: hidden;
      left: 0;
      width: 100%;
      font-size: 55px;
      font-weight: 700;
      line-height: 100%;
      color: #E31010;
      mix-blend-mode: screen;

      &.group-1 {
        top: 0;
        left: 2px;

        .first {
          display: block;
          height: 100%;
        }
      }

      &.group-2 {
        bottom: 0;

        .second {
          bottom: 0;
          position: absolute;
          left: 0;
        }
      }

      .first:before,
      .second:before {
        content: attr(title);
        position: absolute;
        left: -2px;
        top: 2px;
        color: var(--extreme-blue);
        width: 100%;
        height: 100%;
      }

      .title-big-1 {
        color: var(--main-light);
        position: absolute;
        left: 0;
        top: 0;

        &:before {
          content: attr(title);
          color: var(--extreme-yellow);
          mix-blend-mode: lighten;
          position: absolute;
          left: 2px;
          top: 0;
          width: 100%;
        }

        &:after {
          content: attr(title);
          color: #E75CEE;
          mix-blend-mode: screen;
          position: absolute;
          left: 0;
          top: -2px;
          z-index: 1;
          width: 100%;
        }
      }
    }
  }

  &.blog {
    height: 140px;

    .groups {
      height: 140px;

      .group-1,
      .group-2 {
        font-size: 140px !important;
      }
    }
  }
}

.cm-fonts {
  filter: drop-shadow(0 0 10px #195FF5);

  .groups {
    .group-1,
    .group-2 {
      font-size: 60px;
      font-weight: 800;

      .first:before,
      .second:before {
        left: -1px;
      }

      .title-big-1 {
        &:before {
          color: var(--extreme-fucsia);
        }

        &:after {
          color: var(--extreme-fucsia);
          left: 2px;
        }
      }
    }
  }
}

@include bp($bp-mobile) {
  .holder-groups {
    height: auto;
    flex-wrap: wrap;
    width: 100%;

    .groups {
      flex: 50%;
      height: 40px;

      &:last-of-type {
        flex: 100%;

        .group-1,
        .group-2 {
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          font-size: 40px;

          .second {
            left: auto;
          }

          .title-big-1 {
            width: 100%;
          }
        }
      }

      .group-1,
      .group-2 {
        font-size: 40px;
      }
    }
  }
}
</style>
